import request from '@/utils/request'

// 查询码上办-威海企业公共品牌申报列表
export function listWhqyggppsb(query) {
  return request({
    url: '/web/whqyggppsb/list',
    method: 'get',
    params: query
  })
}

// 查询码上办-威海企业公共品牌申报详细
export function getWhqyggppsb(whqyggppsbId) {
  return request({
    url: '/web/whqyggppsb/getInfo/' + whqyggppsbId,
    method: 'get'
  })
}

// 新增码上办-威海企业公共品牌申报
export function addWhqyggppsb(data) {
  return request({
    url: '/web/whqyggppsb/add',
    method: 'post',
    data: data
  })
}

// 修改码上办-威海企业公共品牌申报
export function updateWhqyggppsb(data) {
  return request({
    url: '/web/whqyggppsb/edit',
    method: 'post',
    data: data
  })
}

// 删除码上办-威海企业公共品牌申报
export function delWhqyggppsb(whqyggppsbId) {
  return request({
    url: '/web/whqyggppsb/delete/' + whqyggppsbId,
    method: 'post'
  })
}

// 审批码上办-威海企业公共品牌申报
export function audit(data){
  return request({
    url: '/web/whqyggppsb/audit',
    method: 'post',
    data: data
  })
}
